<template>
  <article>
    <TheArticleList
      linkPath="album"
      displayType="album"
      :articles="album.images"
    >
      <TheListTitle :listTitle="album.title" prefix="album" />
      <p class="album__title">{{ album.title }}</p>
      <ArticleHeadMenu
        v-if="album.images"
        :referenceType="2"
        :articleID="album.id"
      />

      <hr class="album__border" />
    </TheArticleList>
  </article>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';

import TheListTitle from "@/components/list/TheListTitle";
import TheArticleList from "@/components/list/TheArticleList";
import ArticleHeadMenu from "@/components/article/ArticleHeadMenu";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "TheAlbum",
  metaInfo() {
    return {
      title: this.album.title ? `${this.album.title} - 圖鑑集` : "圖鑑集",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `${this.album.title} | 臺南宗教藝術`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `關於「${this.album.title}」和其他臺南宗教藝術的美圖都在這裡。`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: this.album.cover_image_url,
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    album() {
      return this.$store.getters.album;
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  async mounted() {
    await this.getAlbumData(this.$route.params.articleId);
    // await lazyloading();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.articleId !== from.params.articleId) {
      this.getAlbumData(to.params.articleId);
    }
    next();
  },
  methods: {
    async getAlbumData(articleId) {
      // 載入藝品文章頁內頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch("getAlbum", articleId);
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    TheListTitle,
    TheArticleList,
    ArticleHeadMenu,
    AccesskeyLink,
  },
};
</script>

<style lang="scss" scoped>
article {
  padding-bottom: 30px;

  .album {
    &__title {
      font-size: 1.5rem;
      color: $color-light-title;
      font-family: $text-font-family;
      margin: 20px 0;
    }

    &__border {
      border-bottom: 1px solid $color-light-border;
      width: calc(100% - 32px);
      margin-top: 20px;
      margin-bottom: 20px;

      @include for-tablet-horizontal {
        max-width: 995px;
      }
    }
  }

  /deep/ .article-head__menu {
    text-align: center;
  }
}
</style>
